import { inject, Injectable } from "@angular/core";
import {
  AlarmFilters,
  LorenAlarmsEndpointsService
} from "./services/loren-alarms-endpoints-service/loren-alarms-endpoints.service";
import { HttpClient } from "@angular/common/http";
import { interval, switchMap } from "rxjs";
import { Alarm } from "../../../features/alarm/alarm.service";
import { startWith } from "rxjs/operators";
import { environment } from "../../../../environments/environment";

interface AlarmResponse {
  page: number;
  size: number;
  total: number;
  data: Alarm[];
}

@Injectable({
  providedIn: "root",
})
export class LorenAlarmsService {
  private http = inject(HttpClient);
  private alarmsEndpointsService = inject(LorenAlarmsEndpointsService);
  private interval$ = interval(30_000).pipe(startWith(0));

  getAllAlarms() {
    return this.http.get(this.alarmsEndpointsService.getAlarms(), {});
  }

  getAllAlarmsForAsset(page = 0, perPage = 20, assetId: number) {
    return this.http.get<{ data: Alarm[]; total: number }>(
      this.alarmsEndpointsService.getAllAlarmsForAsset(page, perPage, assetId),
      {}
    );
  }

  getActiveAlarms(page = 0, size = 100, filter: AlarmFilters = {}) {
    // Ugly workaround - there are two endpoints for fetching alarms.
    // The one which doesn't support filter needs to be removed
    return this.interval$.pipe(
      switchMap(() => this.http.get<AlarmResponse>(`${environment.apiServerUrl}/alarms`, {
        params: {
          status: 'ACTIVE',
          page,
          size,
          ...filter,
        }
      }))
    )
  }

  getFilteredAlarmsForAsset(
    page: number,
    perPage: number,
    assetId: number,
    filter
  ) {
    return this.http.get<{ data: Alarm[]; total: number }>(
      this.alarmsEndpointsService.getFilteredAlarmsForAsset(
        page,
        perPage,
        assetId,
        filter
      ),
      {}
    );
  }
}
